import { IntlShape, MessageDescriptor } from "react-intl";
import { format, isValid, parseISO } from "date-fns";
import { SupportType } from "actions/reportActions";

/** Parse strings the same way as former date-and-time UTC parse (normalized YYYY-MM-DD HH:mm:ss). */
function parseIncomingDate(date: string | Date): Date | undefined {
  if (date instanceof Date) {
    return isValid(date) ? date : undefined;
  }
  const normalized = date.replace("T", " ").replace(/\..*$|T/gm, "").trim();
  if (!normalized) return undefined;
  const utcIso = normalized.includes(" ")
    ? `${normalized.replace(" ", "T")}Z`
    : `${normalized}Z`;
  const parsed = parseISO(utcIso);
  return isValid(parsed) ? parsed : undefined;
}

export const convertYesNoToBool = (selected: string) => {
  return (selected === "Yes") ? true :  false; 
}

export const convertBoolToYesNo = (value: any) => {
  return (value && parseInt(value)) ? "Yes" : "No";
}

export const convertBoolToYesNoIntl = (value: any) => {
  return (value && parseInt(value)) 
          ? { id: "common.yes", defaultMessage: "Yes" }
          : { id: "common.no", defaultMessage: "No" };
}

export const isUndefined = (input: any) => {
  return ( input === undefined );
}

export const getTranslatedText = (intl: IntlShape, messageDescriptor?: MessageDescriptor) => {
  if (messageDescriptor) {
    messageDescriptor.defaultMessage = messageDescriptor.defaultMessage || `${messageDescriptor.id}`;
    return intl.formatMessage(messageDescriptor);
  }
  return "";
}

export enum DateFormStyle {
  None = "None",
  Text = "Text",
  TextDateTime = "TextDateTime",
  DateTime = "DateTime"
};

export const dateFormatter = (date: string | Date, style: DateFormStyle = DateFormStyle.None, useDateTime = false ) => {
  const parsedDate = parseIncomingDate(date);

  if (!parsedDate) {
    return "";
  }

  if (style === DateFormStyle.TextDateTime) {
    return format(parsedDate, "MMMM dd, yyyy hh:mm a");
  }
  if (style === DateFormStyle.Text) {
    return format(parsedDate, "MMMM dd, yyyy");
  }
  if (style === DateFormStyle.DateTime) {
    return format(parsedDate, "yyyy-MM-dd HH:mm");
  }

  if (useDateTime) {
    return format(parsedDate, "yyyy-MM-dd HH:mm");
  }
  return format(parsedDate, "MMMM dd, yyyy");
};

export const convertTypesOfSupportToValue = (typesOfSupport: SupportType[] | undefined) => {
  let val = '';
  if (typesOfSupport) {
    for (const type of typesOfSupport) {
      val += type.text + "\n"
    }
  }
  return val;

}
